import React, { useMemo } from 'react';
import { GALLERY_ITEMS } from '../mock';

// Full-bleed animated masonry columns for the hero background.
// Columns auto-scroll vertically in alternating directions using GPU transforms.
export default function HeroGallery() {
  const columns = useMemo(() => {
    const cols = [[], [], [], [], []];
    GALLERY_ITEMS.forEach((item, i) => cols[i % 5].push(item));
    return cols;
  }, []);

  const durations = [46, 58, 40, 64, 50];

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="flex h-full min-w-full justify-center gap-3 px-3 opacity-[0.55]">
        {columns.map((col, ci) => {
          const doubled = [...col, ...col, ...col];
          const dir = ci % 2 === 0 ? 'anim-scroll-up' : 'anim-scroll-down';
          return (
            <div
              key={ci}
              className={`flex w-1/3 shrink-0 flex-col gap-3 sm:w-1/4 md:w-1/5 ${dir}`}
              style={{ animationDuration: `${durations[ci]}s` }}
            >
              {doubled.map((item, idx) => (
                <div key={`${item.id}-${idx}`} className="overflow-hidden rounded-lg border border-white/5">
                  <img
                    src={item.src}
                    alt=""
                    loading={idx < 3 ? 'eager' : 'lazy'}
                    className="h-full w-full object-cover"
                  />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
